import React from 'react'

import { ListItemCollapsed } from './../ListItemCollapsed'
import { ListItem } from './../ListItem'
import { ListProps } from './list.types'
import * as S from './list.styles'

export const List = ({ options, isCollapsed }: ListProps) => {
    return (
        <S.ListWrapper>
            {options.map((option, key) => {
                return isCollapsed ? (
                    <ListItemCollapsed key={key} option={option} />
                ) : (
                    <ListItem key={key} option={option} />
                )
            })}
        </S.ListWrapper>
    )
}
